import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { withTranslation } from 'react-i18next';
import CustomLoadingCellRenderer from './customLoadingCellRenderer';

class iLocalAGGrid extends Component {
    constructor(props) {
        super(props);

        this.state = {            
            loadingCellRenderer: CustomLoadingCellRenderer,
            loadingCellRendererParams: {
                loadingMessage: 'Please Wait...',
            }
        };
    }

    render() {
        const {
            gridHeight,
            columnDefs,
            rowData,
            sideBar,
            suppressMenuHide,
            onGridReady,
            rowModelType,
            enableSorting,
            enableFilter,
            floatingFilter,
            enableColResize,
            rowSelection,
            defaultColDef,
            cacheBlockSize,
            maxBlocksInCache,
            rowBuffer,
            onRowSelected,
        } = this.props;
        const {
            loadingCellRendererParams,
            loadingCellRenderer
        } = this.state;
        return (
            <div className="ag-theme-alpine" style={{ height: gridHeight, boxSizing: "border-box", width: "100%" }}>
                <AgGridReact
                    rowBuffer={rowBuffer}
                    rowModelType={rowModelType}
                    cacheBlockSize={cacheBlockSize}
                    maxBlocksInCache={maxBlocksInCache}
                    columnDefs={columnDefs}
                    rowData={rowData}
                    sideBar={sideBar}
                    suppressMenuHide={suppressMenuHide}
                    onGridReady={onGridReady}
                    loadingCellRenderer={loadingCellRenderer}
                    loadingCellRendererParams={loadingCellRendererParams}
                    enableSorting={enableSorting}
                    enableFilter={enableFilter}
                    floatingFilter={floatingFilter}
                    enableColResize={enableColResize}
                    rowSelection={rowSelection}
                    defaultColDef={defaultColDef}
                    onRowSelected={onRowSelected}
                />
            </div>
        );
    }
}

export default (withTranslation()(iLocalAGGrid));


// WEBPACK FOOTER //
// ./src/components/grid/iLocalAGGrid.js